import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

/** Sesión de administrador basada en cookie httpOnly. */
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState("checking"); // checking | authed | guest

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/me");
      setUser(data);
      setStatus("authed");
      return data;
    } catch (e) {
      setUser(null);
      setStatus("guest");
      return null;
    }
  }, []);

  const login = useCallback((usr) => {
    setUser(usr);
    setStatus("authed");
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/admin/auth/logout");
    } catch (e) {
      console.warn("No se pudo cerrar la sesión de administrador:", e);
    }
    setUser(null);
    setStatus("guest");
    window.location.href = "/admin";
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <AuthContext.Provider value={{
      user, login, logout, refresh,
      isAuthed: status === "authed", checking: status === "checking",
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
